import { create } from "zustand";
export const useCompanyStore = create((set) => ({
  persons: null,
  company: null,
  companyList: null,
  setPersons: (persons) => set({ persons }),
  setCompany: (company) => set({ company }),
  setCompanyList: (companyList) => set({ companyList }),
}));
